 $(function() {
    var testimonialStars = '';
    var t_rating = '';
    //console.log(t_rating);

    if(t_rating >= 4.51 && t_rating <= 5.00 ){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/5_starsT.png?v=1623919029" alt="5 Stars" />';
    }
    else if(t_rating >= 4.10 && t_rating <= 4.50){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/4_5_starsT.png?v=1623919029" alt="4 TO 5" />';
    }
    else if(t_rating >= 3.51 && t_rating <= 4.00){
      testimonialStars = '<img src="<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/4_starsT.png?v=1623919029" alt="4 Stars" />';
    }
    else if(t_rating >= 3.10 && t_rating <= 3.50){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/3_5_starsT.png?v=1623919029" alt="3 TO 4" />';
    }
    else if(t_rating >= 2.51 && t_rating <= 3.00){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/3_starsT.png?v=1623919029" alt="3 Stars" />';
    }
    else if(t_rating >= 2.10 && t_rating <= 2.50){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/2_5_starsT.png?v=1623919029" alt="2 TO 3" />';
    }
    else if(t_rating >= 1.51 && t_rating <= 2.00){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/2_starsT.png?v=1623919029" alt="2 Stars" />';
    }
    else if(t_rating >= 1.10 && t_rating <= 1.50){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/1_5_starsT.png?v=1623919029" alt="1 TO 2" />';
    } 
    else if(t_rating >= 1.00){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/1_starT.png?v=1623919029" alt="1 Stars" />';
    }
    else if(t_rating < 1.00){
      testimonialStars = '<img src="https://cdn.shopify.com/s/files/1/0308/8020/2883/files/0_starsT.png?v=1623919029" alt="0 Stars" />';
    };


    $('.testimonialReviews').append(
      '<div itemscope itemtype="http://schema.org/LocalBusiness"> ' +
      '<meta itemprop="name" content="https://www.slimbox.de/">' +
      '<div itemprop="ratingStars" class="ratingStars">'+ 
      '<span itemprop="Stars" class="stars_">' + testimonialStars + '</span>' +
      '<span itemprop="Stars" class="rating_">(' + t_rating + ')</span>' +
      '</div>' +
      '</div>'
    );
  });